import { render, staticRenderFns } from "./OsNotificationButton.vue?vue&type=template&id=ef7bd7ca&scoped=true&"
import script from "./OsNotificationButton.vue?vue&type=script&lang=js&"
export * from "./OsNotificationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7bd7ca",
  null
  
)

export default component.exports